export default __webpack_public_path__ + "3a99e70aee4076660d38b312c7cac2f9.woff";